module.exports = __webpack_public_path__ + "img/31.36dd5f55.svg";